<template>

	<ul class="primary-nav">
		<li class="primary-item" @mouseover="showProductNav = true" @mouseleave="showProductNav = false">
			<button class="primary-link">
				Products
				<sprite name="arrow" class="drop-arrow" />
			</button>
			<ul class="secondary-nav" v-if="showProductNav">
				<li class="secondary-item">
					<router-link :to="{name: 'productsEla'}" class="link">
						<div class="icon">
							<sprite name="ela" />
						</div>
						<div>
							<div class="label">StudySync<mark>ELA</mark></div>
							<div class="description">Comprehensive English Language Arts Curriculum for Grades 6 - 12</div>
						</div>
					</router-link>
				</li>
				<li class="secondary-item">
					<router-link :to="{name: 'productsSyncblasts'}" class="link">
						<div class="icon">
							<sprite name="ela" />
						</div>
						<div>
							<div class="label">Sync<mark>Blasts</mark></div>
							<div class="description">Cross-Curricular, Inquiry-Based, Reading and Writing Solution</div>
						</div>
					</router-link>
				</li>
				<li class="secondary-item">
					<router-link :to="{name: 'productsGlobal'}" class="link">
						<div class="icon">
							<sprite name="ela" />
						</div>
						<div>
							<div class="label">StudySync<mark>Global</mark></div>
							<div class="description">A Rigorous Global English Language Arts Curriculum</div>
						</div>
					</router-link>
				</li>
			</ul>
		</li>
		<li class="primary-item">
			<router-link :to="{name: 'ourCompany'}" class="primary-link">Company</router-link>
		</li>
		<li class="primary-item menu">
			<button @click.prevent="toggleNav" class="primary-link">
				<sprite name="menu" class="menu-icon" />
				<span class="label">Menu</span>
			</button>
		</li>
	</ul>

</template>

<script>

	export default {
		name: 'primaryNav',
		data () {
			return {
				showProductNav: false
			}
		},
		methods: {
			toggleNav () {
				this.$store.commit('app/toggleOverlayNav')
			}
		},
		watch: {
			'$route' () {
				this.showProductNav = false
			}
		}
	}

</script>

<style lang="scss" scoped>

	@import "media";
	@import "list-style-reset";
	@import "responsive-font";

	ul {
		@include list-style-reset;
	}

	a {
		text-decoration:none;
	}

	.drop-arrow {
		fill:#ffffff; width:1.4rem; height:1.4rem; vertical-align:middle; margin-left:.2rem;
	}

	.primary {
		&-nav {
			display:flex;
		}
		&-item {
			position:relative; padding:0 0 0 1.3rem; margin-left:3rem;
			@include media(small, large) {
				display:none;
			}
			&.menu {
				@include media(small) {
					display:block;
				}
				.primary-link {
					@include responsive-font(10);
					display:flex; align-items:center;
					.menu-icon {
						width:auto; height:1.5em; margin-right:1em;
					}
					.label {
						@include responsive-font(17);
						@include media(small) {
							font-size:2.1rem;
						}
					}
				}
			}
		}
		&-link {
			@include responsive-font(17);
			border:none; padding:0; width:auto; background:transparent; outline:none; font-weight:600; line-height:1; color:#ffffff; cursor:pointer;
		}
	}

	.secondary {
		&-nav {
			@include responsive-font(10);
			background:rgba(#3d3d3d, .95); padding:3em; position:absolute; top:100%; right:0; transform:translateX(50%); min-width:35em; border-radius:.5rem; z-index:101;
			&:before {
				content:""; width:0; height:0; border-left:5px solid transparent; border-right:5px solid transparent; border-bottom:5px solid #3d3d3d; position:absolute; top:0; right:50%; transform:translate(-25%, -100%);
			}
			.link {
				display:flex;
			}
			.icon {
				display:none; margin-right:1.5em;
				svg {
					width:3em; height:auto;
				}
			}
			.label {
				@include responsive-font(20);
				font-family:"Oswald"; text-transform:uppercase; font-weight:400; color:#fff; line-height:1; margin-bottom:.25em;
				mark {
					color:#FDB913;
				}
			}
			.description {
				@include responsive-font(15);
				font-weight:400; color:rgba(#fff, .7);
			}
			a:hover .description {
				color:#fff;
			}
		}
		&-item + &-item {
			margin-top:2em;
		}
	}

	.primary-item:hover .secondary-nav {
		display:block;
	}

	.menu-icon {
		fill:#fff; width:2.4em;
	}

</style>



// WEBPACK FOOTER //
// src/components/PrimaryNav/index.vue